module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4zn.f4cb4718.jpg";